<template>
  <div class="login">
    <heads></heads>
    <div class="bg-wrapper">
      <div class="container">
        <div class="flex-wrapper">
          <div class="text-wrapper">
            <img src="../../static/images/logo.png" alt>
            <div class="text01">企业立项查询公共服务平台</div>
            <div class="text02">优惠政策公共服务平台</div>
            <div class="text03">科技项目线上评估中心</div>
          </div>
          <div class="flex-right">
            <div class="login-wrapper">
              <div class="login-title">
                <i class="fa fa-edit fa-lg"></i>
                登录/Login
              </div>
              <div class="login-tab">
                <div class="tab-item" :class="[tab == 1 ? 'item-active' : '']" @click="tab = 1">密码登录</div>
                <!-- <div class="tab-item" :class="[tab == 2 ? 'item-active' : '']"><a href="https://open.weixin.qq.com/connect/qrconnect?appid=wxc5bcdfd664233f11&redirect_uri=http://www.zhengyirc.com%2F%23%2Fwx&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect"
            >微信登录</a></div> -->
            <div class="tab-item" :class="[tab == 2 ? 'item-active' : '']" @click="tab = 2">微信登录</div>
              </div>
              <div v-if="tab == 1">
                <div class="input-wrapper">
                  <input type="text" name placeholder="账号" v-model="account" @keyup.enter="submit">
                  <input type="password" name placeholder="密码" v-model="password" @keyup.enter="submit">
                </div>
                <div class="tips-wrapper">
                  <div class="tips-item">
                    <el-checkbox v-model="RememberPassword">记住账号</el-checkbox>
<!--                    <el-checkbox v-model="agreementChecked">我已阅读并同意</el-checkbox><span @click="dialogVisible = true">《用户协议》</span>-->
                  </div>
                </div>
                <div class="btn" @click="submit" >登录</div>
                <div class="bottom-tips">
                  <span @click="toRegistered">注册</span>
                  <span>|</span>
                  <span @click="toFogetPassword">忘记密码</span>
                  <span>|</span>
                  <span>
                    <router-link :to="'/aboutUs/4'">帮助中心</router-link>
                  </span>
                </div>
              </div>
              <div class="qr-wrapper" v-else>
                <wxlogin :href="href" :appid="appid" :scope="scope" :theme='style' :state='state' :redirect_uri="redirect_uri"></wxlogin>
                <!-- <div>使用微信，扫描二维码登录</div> -->
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div id="foots" class="foots">
        <div class="container">

          <div
            class="footer-bottom"
          >{{basicInfo.archiveInformation}}</div>
        </div>
      </div>
      <el-dialog
          title="用户协议"
          :visible.sync="dialogVisible"
          width="80%"
          :before-close="handleClose">
          <p>这是用户协议</p>
          <p>这是用户协议这是用户协议</p>
          <p>这是用户协议这是用户协议</p>
          <p>这是用户协议</p>
          <p>这是用户协议这是用户协议</p>
          <p>这是用户协议</p>
          <p>这是用户协议</p>
          <p>这是用户协议这是用户协议这是用户协议这是用户协议这是用户协议</p>
          <p>这是用户协议这是用户协议这是用户协议这是用户协议这是用户协议这是用户协议这是用户协议这是用户协议这是用户协议这是用户协议这是用户协议这是用户协议</p>
          <p>这是用户协议</p>
          <p>这是用户协议</p>
          <p>这是用户协议</p>
          <p>这是用户协议</p>
          <p>这是用户协议</p>
          <p>这是用户协议</p>
          <!-- <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
          </span> -->
        </el-dialog>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import foots from "@/components/comment/foots.vue";
import CryptoJS from 'crypto-js'
import axios from "axios";
import wxlogin from 'vue-wxlogin';
export default {
  name: "login",
  data() {
    return {
      showwx: false,
      appid: 'wxc5bcdfd664233f11',
      scope: 'snsapi_login',
      state: 'bind',
      style: 'black',
      redirect_uri: 'http://www.zhengyirc.com%2F%23%2Fwx',
      href:'https://www.zhengyirc.com/static/images/wcCode.css',

      tab: 1,
      account: "",
      password: "",
      agreementChecked: true,
      basicInfo: "",
      dialogVisible: false,
      RememberPassword:false,
      fromRou:''
    };
  },
  components: {
    heads,
    foots,wxlogin
  },
  mounted() {
    // this.getInfo();
    this.getCookie()
  },
  beforeRouteEnter(to, from, next) {
      next(vm=>{
          vm.fromRou=from.name
       // if (from.name=='registered'||from.name==null){
       //     next({name: '/'})
       // }
      })
  },
  methods: {
    handleClose(done) {
        this.dialogVisible = false;
    },
    toRegistered() {
      this.$router.push({ path: "/registered" });
    },
    toFogetPassword(){
      this.$router.push({path:"/forgetPassword"});
    },

    //基本信息
    getInfo() {
      axios
        .get(`/mobile/cmWebBasicConfig/getCmWebBasicConfigById.jhtml`)
        .then(res => {
          this.loading = false;
          if (res.data.success) {
            this.basicInfo = res.data.output;
          } else {
            this.$message({
                message:"系统繁忙，请稍后再试~",
                center:true,
                type:"warning",
                duration:1500
            });
          }
        });
    },
    submit() {
      if (this.account == "" || this.password == "") {
        return this.$message({
           message:"请填写完整信息~",
            center:true,
            type:"warning",
            duration:1500
        });
      }
      axios
        .get(`/login/mobilesubmit.jhtml`, {
          params: {
            password: this.password,
            mobile: this.account
          }
        })
        .then(res => {
          this.loading = false;
          if (res.data.type == "success") {

            this.$store.commit("saveToken", res.data.content);
            this.$store.dispatch("getMember");
              const self = this;
                if(self.RememberPassword){
                    self.setCookie(self.account,self.password,7)
                }else {
                    self.clearCookie();
                }

                if (this.fromRou==null||this.fromRou=='registered'){
                    this.$message({
                        message: '请及时完善用户资料',
                        center: true,
                        type:"warning",
                        duration:1500
                    });
                    this.$router.push({path:'user?nav=1'})
                }else {

                    this.$message({
                        message:"登录成功~",
                        center: true,
                        type:"warning",
                        duration:1500
                    });
                    this.$router.go(-1);
                }

          } else {
            this.$message({
                message: res.data.content,
                center: true,
                type:"warning",
                duration:1500
            });
          }
        });
    },
      setCookie(c_name, c_pwd, exdays) {
          var cipherC=CryptoJS.AES.encrypt(c_name+'',"secretkey123").toString()
          var cipherP=CryptoJS.AES.encrypt(c_pwd+'',"secretkey123").toString()
          var exdate = new Date(); //获取时间
          exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
          //字符串拼接cookie
          window.document.cookie = "userName" + "=" + cipherC + ";path=/;expires=" + exdate.toGMTString();
          window.document.cookie = "userPwd" + "=" + cipherP + ";path=/;expires=" + exdate.toGMTString();
      },
      //读取cookie
      getCookie: function() {
          if (document.cookie.length > 0) {
              var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
              for (var i = 0; i < arr.length; i++) {
                  var arr2 = arr[i].split('='); //再次切割
                  //判断查找相对应的值
                  if (arr2[0] == 'userName') {
                      var bytes=CryptoJS.AES.decrypt(arr2[1],"secretkey123")
                      this.account=bytes.toString(CryptoJS.enc.Utf8)-0;
                      // this.account = arr2[1]; //保存到保存数据的地方
                  } else if (arr2[0] == 'userPwd') {
                      var bytes=CryptoJS.AES.decrypt(arr2[1],"secretkey123")
                      this.password=bytes.toString(CryptoJS.enc.Utf8);
                      // this.password = arr2[1];
                  }
              }
          }
      },
      //清除cookie
      clearCookie: function() {
          this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
      }

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .input-wrapper>input{
margin-bottom: 20px;
  }
.foots {
  width: 800px !important;
  background: rgba(0, 0, 0, 0.2) !important;
  padding: 5px 20px !important;
  color: #666 !important;
  line-height: 22px !important;
  color: #eee !important;
  border-radius: 10px !important;
  font-size: 12px;
  position: absolute;
  bottom: 20px;
  left: 50%;
  margin-left: -400px;
}
.foots .container {
  width: 100% !important;
}
.footer-bottom {
  text-align: center !important;
}
.footer-info {
  border-bottom: 1px solid #bbb !important;
}
.footer-info span {
  margin: 0 10px !important;
}
.qr-wrapper {
  margin: 0 30px;
  line-height: 50px;
}
.qr-wrapper img {
  margin: 0 auto;
  display: block;
  width: 150px;
  height: 150px;
}
.login-tab {
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #fff;
  margin-bottom: 15px;
  line-height: 35px;
  box-sizing: border-box;
}
.tab-item {
  color: #fff;
  margin-bottom: -1px;
  cursor: pointer;
}
.item-active {
    color: #106e98;
    border-bottom: 2px solid #106e98;
    font-weight: bold;
}
.login {
  position: absolute;
  width: 100%;
  height: 100%;
}
.btn {
  width: 100%;
  height: 40px;
  line-height: 40px;
  border-radius: 35px;
  text-align: center;
  background: #ff5555;
  color: #fff;
  font-size: 14px;
  margin-top: 10px;
  display: inline-block;
  cursor: pointer;
  margin-bottom: 10px;
}
.bg-wrapper {
  background: url("../../static/images/login-bg.jpg") no-repeat;
  background-size: cover;
  background-position: center;
  padding: 30px 0 100px 0;
  position: fixed;
  height: calc(100% - 61px);
  width: 100%;
}
.flex-wrapper {
  display: flex;
  justify-content: center;
  justify-items: center;
}
.text-wrapper {
  flex: 1;
/*position: fixed;*/
/*  height: 50%;*/
  font-family: STHupo;
  margin: 30px 15px;
  padding-top: 50px;
  color: #fff;
  font-size: 28px;
  line-height: 60px;
  text-align: center;
  font-weight: 100;
}
.text-wrapper img{
 border-radius: 5px;
}
.text01 {
  text-indent: 30px;
}
.text02 {
  text-indent: 60px;
}
.text03 {
  text-indent: 120px;
}
.flex-right {
  flex: 1;
}
.login-wrapper {
  background: rgb(82, 50, 50);
  /* width: 70%; */
  height: 85%;
  width: 400px;
  /*height: 400px;*/
  border-radius: 15px;
  padding: 15px;
  box-sizing: border-box;
  margin: 80px auto 0 auto;
  color: #fff;
}
.login-title {
  font-size: 20px;
  text-align: left;
  margin-bottom: 20px;
}
input {
  border: none;
  background: #fff;
  border-radius: 45px;
  line-height: 45px;
  padding: 0 15px;
  display: block;
  width: 100%;
  margin-bottom: 10px;
  box-sizing: border-box;
  color: #333;
}
.tips-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 5px 10px;
}
.tips-item {
  flex: 1;
  text-align: left;
  font-size: 14px;
  color: #106e98;
  cursor: pointer;
}
.tips-item-right {
  text-align: right;
}
.el-checkbox {
  color: #fff;
}
.bottom-tips {
  text-align: right;
  font-size: 14px;
}
.bottom-tips span {
  cursor: pointer;
  margin-right: 5px;
}
.bottom-tips span a {
  cursor: pointer;
  color: #fff;
}


</style>
<style>
.impowerBox .title,.impowerBox .status p{
  color: #fff !important;
}
.impowerBox{
  width: 260px !important;
}
.impowerBox .qrcode{
  width: 150px !important;
}
.impowerBox .title{
  display: none !important;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
    color: #106e98 !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #106e98 !important;
    border-color: #106e98 !important;
}
</style>




// WEBPACK FOOTER //
// src/components/login.vue